import { IRoundTeesAssignation } from '../../../../../../../store/roundTees/store';

export const isRoundTeeAssignationInvalid = (teeAssignation: Partial<IRoundTeesAssignation>) => {
  const { tee, gender } = teeAssignation;

  return !gender || !tee;
};
